import { ChakraProvider, ColorModeScript } from '@chakra-ui/react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import App from './App';
import { isAuthenticated, keycloak } from './auth/keycloak';
import { setAnalyticsUser } from './firebase/analytics';
import './index.css';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import theme from './theme';

const getLocale = () => {
    // get browser language without the region code
    const language = navigator.language.split(/[-_]/)[0];

    switch (language) {
        // Use this format to add a new language:
        // case 'en':
        //     return require('./translations/en.json');
        default:
            return require('./translations/en.json');
    }
};

const eventLogger = (event: any, error: any) => {
    console.log('onKeycloakEvent', event, error);
};

const tokenLogger = (tokens: unknown) => {
    console.log('onKeycloakTokens', tokens);
};

const onKeycloakEvent = (event: any, error: any) => {
    eventLogger(event, error);
    if (event === 'onAuthSuccess' && isAuthenticated(keycloak)) {
        setAnalyticsUser(keycloak.token, keycloak.subject);
    }
};

const messages = getLocale();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <ReactKeycloakProvider
        authClient={keycloak}
        onEvent={onKeycloakEvent}
        onTokens={tokenLogger}
        initOptions={{ checkLoginIframe: false }}
    >
        <React.StrictMode>
            <ChakraProvider theme={theme}>
                <ColorModeScript initialColorMode={theme.config.initialColorMode} />
                <IntlProvider locale={navigator.language} defaultLocale={'en'} messages={messages}>
                    <App />
                </IntlProvider>
            </ChakraProvider>
        </React.StrictMode>
    </ReactKeycloakProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
